import { IconTile, SubsectionTitle, Subtitle } from '@if/mui'
import { Card, CardHeader, Grid } from '@mui/material'
import { ClipboardCheck, UserRoundCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const HIGHLIGHTS = [
  { key: 'optional', icon: UserRoundCheck },
  { key: 'oneClick', icon: ClipboardCheck },
] as const

export const ProtectionPlanHighlights = () => {
  const { t } = useTranslation()
  return (
    <Grid container spacing={3}>
      {HIGHLIGHTS.map(({ key, icon }) => (
        <Grid key={key} size={{ xs: 12, md: 6 }}>
          <Card sx={{ height: '100%' }}>
            <CardHeader
              disableTypography
              avatar={<IconTile icon={icon} color="accent" />}
              title={<SubsectionTitle>{t(`protectionPlan.highlights.${key}.title`)}</SubsectionTitle>}
              subheader={<Subtitle>{t(`protectionPlan.highlights.${key}.description`)}</Subtitle>}
            />
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}
